import {
  type TextMessagingProviderQueries,
  defTextMessagingProviderQueries,
} from '@kizen/query/text-messaging-provider';
import AxiosService from '__services/AxiosService';

const queries: TextMessagingProviderQueries =
  defTextMessagingProviderQueries(AxiosService);

export const textMessagingProvidersQuery: TextMessagingProviderQueries['textMessagingProvidersQuery'] =
  queries.textMessagingProvidersQuery;
